import React from 'react'
import { Grid, Checkbox, Button } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Divider from '@material-ui/core/Divider'
import clsx from 'clsx'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '@configurator-messages'
import ValidationErrors from '../../../validations/ValidationErrors'
import * as yup from 'yup'
import { Formik, Field, Form } from 'formik'
import LiquidInputAdapter from '@src/components/LiquidInputAdapter'
import { configContext } from '../DnaPlates'
import {
  price,
  ActiveLinkTypeDnaplate,
  ErrorMessage,
  plate,
  PlateProduct,
  CountryCodes,
  WarningKey,
} from '../enum'
import { priceFormatter } from '@src/routes/Configurators/utils/PriceFormatter'
import {
  usePlateSessionFieldMutation,
  useConfAddToMiniCartMutation,
} from '@src/mutations/ConfiguratorTubesMutation.generated'
import {
  SnackbarType,
  useGlobalSnackbar,
} from '@src/components/GlobalSnackbar/globalSnackBarContext'
import { EmptyState } from '../Reducer'
import { dnaPlatesRoute, loginRoute } from '@src/routes'
import { useRouter } from 'next/router'
import AddToCartItems from '@src/routes/Configurators/components/AddToCart/AddToCartItems'
import {
  convertToASCII,
  validateSurrogateCharacters,
} from '@src/routes/Configurators/utils/util'
import CircleLoader from '@src/components/CircleLoader'
import {
  handleGAAddToCartForConfigurator,
  handleGAAddToCartErrorsForConfigurator,
} from '@utils/analytics/configuratorAnalytics'
import {
  ProductNames,
  ConfiguratorValues,
} from '@src/routes/Configurators/utils/constants'
import useDebounce from '@src/routes/Configurators/utils/ConfiguratorDebounce'
import { TubeProperties } from '../../../utils/enum'
import { dropAllKeyInstances } from '@src/utils/ObjectHelpers/dropKeys'

const useStyles = makeStyles((theme: Theme) => {
  return {
    contentWrapper: {
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(2, 6, 2, 10),
    },
    dJustifyFlexEnd: {
      justifyContent: 'flex-end',
    },
    dFlex: {
      display: 'flex',
    },
    w100: {
      width: '100%',
    },
    mgBottom3: {
      marginBottom: theme.spacing(3),
    },
    mgLeft: {
      marginLeft: '35%',
    },
    mgRight: {
      marginRight: '60%',
    },
    mgBottom: {
      marginBottom: theme.spacing(5),
    },
    additionalInfoText: {
      backgroundColor: theme.palette.background.grey,
      border: 'none',
      resize: 'none',
      fontFamily: 'inherit',
    },
    font12: {
      fontSize: theme.typography.pxToRem(12),
    },
    subHead: {
      fontSize: theme.typography.pxToRem(18),
      fontWeight: theme.typography.fontWeightBold,
      margin: theme.spacing(3, 0),
    },
    subTotal: {
      marginBottom: theme.spacing(5),
      display: 'flex',
      fontSize: theme.typography.pxToRem(18),
      fontWeight: theme.typography.fontWeightMedium,
    },
    padding: {
      paddingBottom: theme.spacing(2),
    },
    paddingTop: {
      paddingTop: theme.spacing(2),
    },
    checkBox: {
      paddingLeft: theme.spacing(0),
    },
    listElements: {
      paddingLeft: theme.spacing(6.5),
    },
    uploadDisable: {
      backgroundColor: theme.palette.grey[500],
    },
    additionalcommentmarging: {
      marginBottom: theme.spacing(4),
    },
    checkBoxAcknowledge: {
      padding: theme.spacing(0, 2, 0, 0),
    },
    addToCartMargin: {
      margin: theme.spacing(4, 0, 3, 0),
    },
    errorBorder: {
      fontSize: theme.typography.pxToRem(12),
      margin: theme.spacing(4, 0, 4, 0),
      borderLeft: `${theme.spacing(2)}px solid ${theme.palette.rich.red}`,
      padding: theme.spacing(3, 0, 3, 1.8),
    },
    aknowledgespace: {
      fontSize: theme.typography.pxToRem(12),
      padding: theme.spacing(3, 0, 3, 0),
    },
    fontQuote: {
      fontSize: theme.typography.pxToRem(13),
      fontWeight: theme.typography.fontWeightBold,
    },
    duplexcheckBox: {
      paddingTop: theme.spacing(1.5),
    },
  }
})
interface PlateDetailsForGA {
  productDetails: any
  totalQuantity: number
  price: string
  productName: string
}

const Summary = (props) => {
  const classes = useStyles()
  const [callDebounceCall, setCallDebounceCall] = React.useState(false)
  const intl = useIntl()
  let [splChar] = React.useState<string>('')
  const [validationCommentsErrors, setValidationCommentsErrors] =
    React.useState<string[]>([])
  const { state, dispatch } = React.useContext(configContext)
  const { sessionData, productInformation } = state
  const [commentsCheckBox, setCommentsCheckBox] = React.useState(false)
  const [additionalComments, setAdditionalComments] = React.useState('')
  const [subtotal, setSubtotal] = React.useState<string>('--')
  const [plateSessionField] = usePlateSessionFieldMutation()
  const {
    productDetails,
    updateError,
    configuratorAddToMiniCart,
    setTermsOpen,
  } = props
  const [disableUpload, setDisableUpload] = React.useState(false)
  const { sapNextEnabled } = configuratorAddToMiniCart
  const { companionProducts } = productInformation
  const [acknowledgement, setAcknowledgement] = React.useState(false)
  const [agreeTermsError, setAgreeTermsError] = React.useState(false)
  const debouncedAdditionalData = useDebounce(
    additionalComments,
    TubeProperties.SEQUENCE_API_TIME
  )

  const [addToMiniCart, { data, loading }] = useConfAddToMiniCartMutation({})

  const commentLength = () => {
    let lengthOfComment = 0
    let maxLength = 0
    sessionData.forEach((data) => {
      if (productDetails.productType === PlateProduct.DuplexPlate) {
        data.biTubeWellList.forEach((well) => {
          if (well.comments.length > lengthOfComment) {
            lengthOfComment = well.comments.length
          }
        })
      } else {
        data.wellList.forEach((well) => {
          if (well.comments.length > lengthOfComment) {
            lengthOfComment = well.comments.length
          }
        })
      }
    })
    if (sapNextEnabled) {
      maxLength = 999 - lengthOfComment
    } else {
      maxLength = 90 - lengthOfComment
    }
    return maxLength
  }

  const handleComments = (value) => {
    setCallDebounceCall(true)
    setAdditionalComments(value)
    sessionData.forEach((plate) => {
      if (productDetails.productType === PlateProduct.DuplexPlate) {
        plate.biTubeWellList.forEach((duplexWell) => {
          duplexWell.additionalComments = value
        })
      } else {
        plate.wellList.forEach((well) => {
          well.additionalComments = value
        })
      }
    })
    dispatch({
      type: 'UPDATE_INPUT',
      data: [...state.sessionData],
    })
  }

  const checkSpecialChar = (args): string => {
    splChar = ''
    args.value.split('').forEach((c) => {
      if (c.match(/^[~!@$^|{}?<>%&—’'"]*$/) && !splChar.includes(c)) {
        if (splChar === '') {
          splChar = c
        } else {
          splChar = splChar + ', ' + c
        }
      }
    })
    return splChar
  }

  const additionalCommentsValidation = (value) => {
    value = convertToASCII(value)
    handleComments(value)
    const val = checkSpecialChar({ value })
    const surrogateCharacters = validateSurrogateCharacters(value)
    let invalidCharExist = false
    const validator = yup
      .string()
      .max(
        commentLength(),
        intl.formatMessage(messages.CONF_ADD_INFO_MAX_VALIDATION_MSG) +
          commentLength()
      )
      .matches(
        /^[^~!@$^|{}?<>%&—’'"]*$/,
        `${intl.formatMessage(messages.CONF_SPL_CHAR_VALIDATION_MSG)} ${val}`
      )
    const errors: string[] = []
    try {
      if (surrogateCharacters.length !== 0) {
        setValidationCommentsErrors([
          `${intl.formatMessage(
            messages.CONF_SPL_CHAR_VALIDATION_MSG
          )} ${surrogateCharacters}`,
        ])
        updateError(true)
        setDisableUpload(true)
      } else {
        setValidationCommentsErrors([])
        updateError(false)
        setDisableUpload(false)
      }
      validator.validateSync(value, {
        abortEarly: false,
      })
    } catch (error: any) {
      for (const err of error.errors) {
        if (
          err.includes(
            intl.formatMessage(messages.CONF_SPL_CHAR_VALIDATION_MSG)
          )
        ) {
          surrogateCharacters.length !== 0
            ? errors.push(err + ', ' + surrogateCharacters)
            : errors.push(err)
          invalidCharExist = true
        } else {
          errors.push(err)
        }
      }
      if (!invalidCharExist && surrogateCharacters.length !== 0) {
        errors.push(
          `${intl.formatMessage(
            messages.CONF_SPL_CHAR_VALIDATION_MSG
          )} ${surrogateCharacters}`
        )
      }
      setValidationCommentsErrors(errors)
      updateError(false)
      setDisableUpload(true)
    }
    return undefined
  }

  const sequenceMismatch = () => {
    let count = 0
    sessionData.forEach((data) => {
      data.biTubeWellList.forEach((duplexWell) => {
        if (duplexWell.listWarning.length !== 0) {
          duplexWell.listWarning.forEach((warning) => {
            if (warning.key === WarningKey.antisencesequence_mismatch) {
              count = count + 1
            }
          })
        }
      })
    })
    return count !== 0
  }

  const savePlateDataToSession = async (obj) => {
    await plateSessionField({
      variables: { input: obj, productInput: productDetails },
    })
  }
  React.useEffect(
    () => {
      if (callDebounceCall) {
        setCallDebounceCall(false)
        savePlateDataToSession(sessionData)
      }
    },
    // TODO: need a test before we refactor these dependencies

    [debouncedAdditionalData]
  )

  const router = useRouter()
  const url = `${dnaPlatesRoute.index()}?product=${
    productDetails.productType
  }&activeLink=${ActiveLinkTypeDnaplate.SequenceUpload}`
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const { setGlobalSnackbarState } = useGlobalSnackbar()
  //configuring the Configurator product data for sending it to GA
  const product = router?.query?.product ?? ''
  const itemName = ProductNames[product]
  const qty = sessionData?.length
  let productPrice = 0
  const averagePrice = () => {
    state.platePriceCall.forEach((product) => {
      if (product.totalPrice && product.totalPrice !== price.priceQuote) {
        productPrice = productPrice + Number(product.totalPrice)
      } else {
        productPrice = productPrice + 1
      }
    })
    return (productPrice / qty).toFixed(
      Number(productInformation.currencyFormat)
    )
  }
  const avgPrice = averagePrice()
  let gaPrice
  let gaFormattedPrice
  if (avgPrice) {
    try {
      gaPrice = avgPrice.slice(0, avgPrice.length - 3).replace(/[.,]/g, '')
      gaFormattedPrice =
        gaPrice + avgPrice.slice(avgPrice.length - 3, avgPrice.length)
    } catch {
      gaFormattedPrice = avgPrice
    }
  } else {
    gaFormattedPrice = avgPrice
  }
  const configProductDetails: PlateDetailsForGA = {
    productDetails: state.platePriceCall,
    totalQuantity: qty,
    price: `${gaFormattedPrice}`,
    productName: itemName,
  }

  const handleAcknowledgement = (value) => {
    setAcknowledgement(value)
    setAgreeTermsError(false)
    sessionData.forEach((duplex) => {
      duplex.biTubeWellList.forEach((duplexWell) => {
        duplexWell.terms = value
      })
    })
    dispatch({
      type: 'UPDATE_INPUT',
      data: [...state.sessionData],
    })
    savePlateDataToSession(sessionData)
  }
  const handleAddToCart = async () => {
    await addToMiniCart({
      variables: { input: configuratorAddToMiniCart },
      fetchPolicy: 'no-cache',
    })
  }
  const addToCart = () => {
    if (
      productDetails.productType === PlateProduct.DuplexPlate &&
      sequenceMismatch()
    ) {
      if (acknowledgement) {
        handleAddToCart()
      } else {
        setAgreeTermsError(true)
        setTermsOpen(true)
      }
    } else {
      handleAddToCart()
    }
  }

  const clearSessionData = () => {
    sessionData.splice(0, sessionData.length)
    state.sessionData.push(EmptyState)
    sessionData.forEach((data) => {
      // Drop __typename from the data object and then bind that return to the data on the loop.
      const dataRecast = dropAllKeyInstances(data, ['__typename'])
      data = dataRecast
    })

    dispatch({
      type: 'UPDATE_CURRENT_PLATE_INDEX',
      data: 0,
    })
    dispatch({
      type: 'UPDATE_INPUT',
      data: [...state.sessionData],
    })
    dispatch({ type: 'SET_STEP_NO', data: 0 })
    savePlateDataToSession([])
  }

  React.useEffect(() => {
    if (
      sessionData &&
      ((sessionData.length === 1 &&
        sessionData[0].plateName === plate.NewPlate) ||
        sessionData.length === 0)
    ) {
      router.push(url)
    }
    // TODO: need a test before we refactor these dependencies
  }, [])

  React.useEffect(() => {
    let totalPrice = 0
    let quote = 0
    state.platePriceCall.forEach((plate) => {
      if (plate.totalPrice === price.priceQuote) {
        quote = quote + 1
      }
    })
    if (quote !== 0) {
      setSubtotal(intl.formatMessage(messages._PC_QUOTE_ITEM))
    } else {
      state.platePriceCall.forEach((plate) => {
        totalPrice = totalPrice + parseFloat(plate.totalPrice)
      })
      const formattedPrice = priceFormatter(
        totalPrice,
        productInformation.currencyFormat,
        productInformation.thousandSeparator,
        productInformation.thousandSpacing,
        productInformation.decimalSeparator,
        productInformation.prefixCurrecny,
        state.platePriceCall[0].currencySymbol
      )
      if (formattedPrice !== price.NaN) {
        setSubtotal(formattedPrice)
      } else {
        setSubtotal('--')
      }
    }
    if (productDetails.productType === PlateProduct.DuplexPlate) {
      if (
        sessionData[0].biTubeWellList[0].additionalComments &&
        sessionData[0].biTubeWellList[0].additionalComments.length > 0
      ) {
        setCommentsCheckBox(true)
        setAdditionalComments(
          sessionData[0].biTubeWellList[0].additionalComments
        )
        additionalCommentsValidation(
          sessionData[0].biTubeWellList[0].additionalComments
        )
      }
      setAcknowledgement(sessionData[0].biTubeWellList[0].terms)
    } else {
      if (
        sessionData[0].wellList[0].additionalComments &&
        sessionData[0].wellList[0].additionalComments.length > 0
      ) {
        setCommentsCheckBox(true)
        setAdditionalComments(sessionData[0].wellList[0].additionalComments)
        additionalCommentsValidation(
          sessionData[0].wellList[0].additionalComments
        )
      }
    }

    // TODO: need a test before we refactor these dependencies
  }, [state.platePriceCall])

  const [totalPrice, setTotalPrice] = React.useState<string>('')
  const [totalItem, setTotalItem] = React.useState<number>(0)

  React.useEffect(() => {
    if (data) {
      const errorMessage = ConfiguratorValues.AddToCartFail
      if (data?.confAddToMiniCart?.serverError) {
        updateError(ConfiguratorValues.AddToCartFail)
        //GAtracking event on button click of addToCart

        handleGAAddToCartErrorsForConfigurator(
          configProductDetails,
          errorMessage
        )
      } else {
        if (data?.confAddToMiniCart?.result === ErrorMessage.Success) {
          //GAtracking event on button click of addToCart
          handleGAAddToCartForConfigurator(configProductDetails)
          setTotalPrice(
            state.platePriceCall[0].priceErrorHeader === null ||
              state.platePriceCall[0].priceErrorHeader === ''
              ? subtotal
              : '--'
          )
          setTotalItem(sessionData.length)
          setDialogOpen(true)
          updateError('')
        } else if (
          data?.confAddToMiniCart?.result === ErrorMessage.SessionDataEmpty
        ) {
          clearSessionData()
          router.push(url)
        } else if (
          data?.confAddToMiniCart?.result === ErrorMessage.AccessTokenExpire
        ) {
          updateError('')
          router.push(loginRoute.index())
          setGlobalSnackbarState({
            open: true,
            message: (
              <FormattedMessage
                {...messages.USER_NOT_AUTHORIZED_OR_TOKEN_EXPIRED}
              />
            ),
            variant: SnackbarType.Error,
          })
        } else {
          handleGAAddToCartErrorsForConfigurator(
            configProductDetails,
            errorMessage
          )
          updateError(ConfiguratorValues.AddToCartFail)
        }
      }
    }
    // TODO: need a test before we refactor these dependencies
  }, [data])

  const handleAcknowledgeCheckBox = (value) => {
    setCommentsCheckBox(value)
    if (!value) {
      handleComments('')
      setDisableUpload(false)
      updateError(false)
      setValidationCommentsErrors([])
    }
  }

  return (
    <>
      <Grid className={classes.contentWrapper}>
        <div className={classes.w100}>
          <div className={clsx(classes.mgBottom3, classes.font12)}>
            <h2 className={classes.subHead}>
              <FormattedMessage {...messages.CART_SUMMARY} />
            </h2>
            <Divider />
          </div>
          {productDetails.productType === PlateProduct.DuplexPlate &&
          sequenceMismatch() ? (
            <>
              <div
                className={
                  agreeTermsError
                    ? classes.errorBorder
                    : classes.aknowledgespace
                }
              >
                <Grid container>
                  <Grid item xs={1} sm={1} className={classes.duplexcheckBox}>
                    <Checkbox
                      className={classes.checkBoxAcknowledge}
                      checked={acknowledgement}
                      value={acknowledgement}
                      color="primary"
                      onChange={() => {
                        handleAcknowledgement(!acknowledgement)
                      }}
                    />
                  </Grid>
                  <Grid xs={11} sm={11}>
                    <FormattedMessage
                      {...messages.CONF_DUPLEX_SUMMARY_AKNOWLEDGEMENT}
                    />
                  </Grid>
                </Grid>
              </div>
            </>
          ) : (
            ''
          )}
          <Grid container className={classes.subTotal}>
            <Grid item xs={4} sm={4}>
              <FormattedMessage {...messages.CONF_SUBTOTAL_DNA_PLATES} />
            </Grid>
            <Grid
              item
              xs={8}
              sm={8}
              className={clsx(classes.dFlex, classes.dJustifyFlexEnd)}
            >
              {state.platePriceCall[0].priceErrorHeader === null ||
              state.platePriceCall[0].priceErrorHeader === ''
                ? subtotal
                : '--'}
            </Grid>
          </Grid>
          <div className={classes.mgBottom}>
            {subtotal === intl.formatMessage(messages._PC_QUOTE_ITEM) ? (
              <span className={classes.fontQuote}>
                <FormattedMessage {...messages.CART_QUOTATION_TEXT} />{' '}
              </span>
            ) : (
              <div className={classes.font12}>
                <strong>
                  {' '}
                  <FormattedMessage {...messages.CONF_NOTE} />{' '}
                </strong>
                <FormattedMessage {...messages.CONF_PRICE_SUB_TOTAL} />
              </div>
            )}
            <div className={classes.font12}>
              <ul className={classes.listElements}>
                <li className={classes.padding}>
                  <FormattedMessage {...messages.CONF_POINT_ONE_DNA_PLATES} />
                </li>
                <li className={clsx(classes.mgBottom, classes.padding)}>
                  <FormattedMessage {...messages.CONF_PROMOTIONAL_CODES} />
                </li>
              </ul>
            </div>
          </div>
          {CountryCodes.JP === productDetails.countryCode ? (
            ''
          ) : (
            <>
              <div className={clsx(classes.font12, classes.paddingTop)}>
                <h3>
                  <FormattedMessage
                    {...messages.CONF_ADDITIONAL_SHIPPING_INFO}
                  />
                </h3>
              </div>
              <div className={classes.font12}>
                <Checkbox
                  className={classes.checkBox}
                  checked={commentsCheckBox}
                  value={commentsCheckBox}
                  color="primary"
                  onChange={() => {
                    handleAcknowledgeCheckBox(!commentsCheckBox)
                  }}
                />
                <FormattedMessage {...messages.CONF_ACKNOWLEDGE_DNA_PLATES} />
              </div>
              <div>
                <Formik
                  initialValues={{ addInfo: '' }}
                  validateOnChange
                  onSubmit={(values, actions) => {
                    setTimeout(() => {
                      actions.setSubmitting(false)
                    }, 1000)
                  }}
                >
                  {() => {
                    return (
                      <Form>
                        <div
                          className={clsx(
                            classes.additionalcommentmarging,
                            classes.font12
                          )}
                        >
                          <Field
                            name="addInfo"
                            component={LiquidInputAdapter}
                            placeholder={intl.formatMessage(
                              messages.CONF_ENTER_ADDITIONAL_INFO
                            )}
                            multiline
                            spellcheck={'false'}
                            rows={6}
                            rowsMax={30}
                            value={additionalComments}
                            filled
                            className={clsx(
                              classes.w100,
                              classes.additionalInfoText
                            )}
                            disabled={!commentsCheckBox}
                            validate={(value) => {
                              additionalCommentsValidation(value)
                            }}
                            inputProps={{
                              'data-scrub': 'true',
                            }}
                          />
                          <ValidationErrors errors={validationCommentsErrors} />
                        </div>
                      </Form>
                    )
                  }}
                </Formik>
              </div>
            </>
          )}
          <div
            className={clsx(
              classes.w100,
              classes.font12,
              classes.addToCartMargin
            )}
          >
            <Button
              variant="contained"
              color="primary"
              className={clsx(
                classes.w100,
                disableUpload && classes.uploadDisable
              )}
              disabled={loading || disableUpload}
              onClick={addToCart}
              id="plates-add-to-cart"
              data-testid="plates-add-to-cart"
            >
              <FormattedMessage id="ADD_TO_CART" defaultMessage="Add to Cart" />
            </Button>
          </div>
          <AddToCartItems
            dialogOpen={dialogOpen}
            setDialogOpen={setDialogOpen}
            price={totalPrice}
            totalItem={totalItem}
            companionProducts={companionProducts}
            productType={productDetails.productType}
          />
        </div>
      </Grid>
      {loading && <CircleLoader />}
    </>
  )
}
export default Summary
